import React from 'react';

import Box from '../Box/Box';
import name from './name';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TTextFieldSuffix = {
  kind?: 'icon';
  children?: React.ReactNode;
};

const TextFieldSuffix = ({ kind, ...rest }: TTextFieldSuffix) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return <Box {...rest} {...conditionalProps} as="span" name="suffix" parent={name} />;
};

export default TextFieldSuffix;
